import rules from '@/utils/validate.js';
/**
 * 不动产基本信息
 */
//不动产权证号
const bdcqzh = {
  title: '不动产权证号',
  span: 24,
  type: 'chooseBdcqzh',
  key: 'bdcqzh',
  props: {
    mbanType: '证书模板',
    disabled: true,
  },
  rule: [rules.required],
};
//不动产权证号
const bdcqzhNoreq = {
  title: '不动产权证号',
  span: 24,
  type: 'chooseBdcqzh',
  key: 'bdcqzh',
  props: {
    mbanType: '证书模板',
  },
};

const tdsyqmj = {
  title: '土地使用权面积(㎡)',
  span: 12,
  type: 'input',
  key: 'tdsyqmj',
  props: {
    placeholder: '请填写土地使用权面积',
  },
  rule: [rules.required],
};
//坐落
const zl = {
  title: '不动产坐落',
  span: 24,
  type: 'zl',
  key: 'zl',
  props: {
    placeholder: '请填写不动产坐落',
    disabled: true,
  },
  rule: [rules.required],
};

//不动产单元号
const bdcdyh = {
  title: '不动产单元号',
  span: 12,
  type: 'input',
  key: 'bdcdyh',
  props: {
    placeholder: '请填写不动产单元号',
    disabled: true,
  },
  rule: [rules.required, rules.estateUnitNo],
};
// 土地使用结束时间
const tdsyqjssj = {
  title: '土地使用结束时间',
  span: 12,
  type: 'date',
  key: 'syqjssj',
  props: {
    placeholder: '请填写土地使用结束时间',
  },
  rule: [rules.required],
};
const tdsyqqssj = {
  title: '土地使用开始时间',
  span: 12,
  type: 'date',
  key: 'syqqssj',
  props: {
    placeholder: '请填写土地使用开始时间',
  },
  rule: [],
};
//房屋产权面积
const fwcqmj = {
  title: '房屋产权面积(㎡)',
  span: 12,
  type: 'input',
  key: 'fwcqmj',
  props: {
    placeholder: '请填写房屋产权面积(㎡)',
  },
  rule: [rules.required, rules.number, rules.min(1)],
};

//房屋交易价格
const fwjyjg = {
  title: '房屋交易价格(万元)',
  span: 12,
  type: 'input',
  key: 'fwjyjg',
  props: {
    placeholder: '请填写房屋交易价格(万元)',
    disabled: true,
  },
  rule: [rules.required, rules.number, rules.min(0)],
};

//房屋交易价格不必填
const fwjyjgNotRequired = {
  title: '房屋交易价格(万元)',
  span: 12,
  type: 'input',
  key: 'fwjyjg',
  props: {
    placeholder: '请填写房屋交易价格(万元)',
  },
  rule: [rules.number],
};
//房屋交易价格必填
const fwjyjgRequired = {
  title: '房屋交易价格(万元)',
  span: 12,
  type: 'input',
  key: 'fwjyjg',
  props: {
    placeholder: '请填写房屋交易价格(万元)',
  },
  rule: [rules.required, rules.number],
};

//交易价格必填
const jyjgNewRequired = {
  title: '交易价格(万元)',
  span: 12,
  type: 'input',
  key: 'fwjyjg',
  props: {
    placeholder: '请填写交易价格(万元)',
  },
  rule: [rules.required, rules.number],
};

//预测面积必填
const ycjzmjRequired = {
  title: '预测面积',
  span: 12,
  type: 'input',
  key: 'ycjzmj',
  props: {
    placeholder: '请填写预测面积',
  },
  rule: [rules.required, rules.number],
};

// 取得价格必填
const qdjgRequired = {
  title: '取得价格(万元)',
  span: 12,
  type: 'input',
  key: 'fwjyjg',
  props: {
    placeholder: '请填写取得价格(万元)',
  },
  rule: [rules.required, rules.number],
};
// 取得价格非必填
const qdjgNotRequired = {
  title: '取得价格(万元)',
  span: 12,
  type: 'input',
  key: 'fwjyjg',
  props: {
    placeholder: '请填写取得价格(万元)',
  },
  rule: [rules.number],
};

//土地使用权人
const tdsyqr = {
  title: '土地使用权人',
  span: 12,
  type: 'input',
  key: 'tdsyqr',
  props: {
    placeholder: '请填写土地使用权人',
  },
  rule: [rules.required],
};

/**
 * 不动产扩展信息
 */
// 申请证书模板
const sqzsbs = {
  title: '申请证书模板',
  span: 24,
  type: 'dicSelect',
  key: 'sqzsbs',
  props: {
    placeholder: '请选择申请证书模板',
    type: '申请证书模板',
  },
  value: '0',
  rule: [rules.required],
};
// 签约日期
const gfhtqdrq = {
  title: '签约日期',
  span: 12,
  type: 'date',
  key: 'gfhtqdrq',
  props: {
    placeholder: '请填写签约日期',
  },
  rule: [rules.required],
};
// 建筑结构类型
const jzjg = {
  title: '建筑结构类型',
  span: 12,
  type: 'dicSelect',
  key: 'jzjg',
  props: {
    placeholder: '请选择建筑结构类型',
    type: '建筑结构类型',
  },
  rule: [rules.required],
};
// 是否分别持证
const sffbcz = {
  title: '是否分别持证',
  span: 12,
  type: 'radio',
  key: 'sffbcz',
  props: {
    placeholder: '请选择是否分别持证',
    options: [
      {
        value: 'true',
        label: '是',
      },
      {
        value: 'false',
        label: '否',
      },
    ],
  },
  value: 'false',
  rule: [rules.required],
};

// 是否分多本证
const sfdbz = {
  title: '是否分多本证',
  span: 12,
  type: 'radio',
  key: 'sfdbz',
  props: {
    placeholder: '请选择是否分多本证',
    options: [
      {
        value: 'true',
        label: '是',
      },
      {
        value: 'false',
        label: '否',
      },
    ],
  },
  value: 'false',
  rule: [rules.required],
};

//申请登记原因
const sqdjyy = {
  title: '申请登记原因',
  span: 24,
  type: 'dicSelect',
  key: 'sqdjyy',
  props: {
    placeholder: '请选择/填写申请登记原因',
    type: '申请登记原因',
    allowCreate: true,
    filterable: true,
  },
  rule: [rules.required],
};

/**
 * 查封信息
 */
//原告人
const ygr = {
  title: '原告人',
  span: 12,
  type: 'input',
  props: {
    placeholder: '请填写原告人',
  },
  key: 'ygr',
};

//查封类型
const cflx = {
  title: '查封类型',
  span: 12,
  type: 'dicSelect',
  key: 'cflx',
  props: {
    placeholder: '请选择查封类型',
    type: '查封类型',
  },
  rule: [rules.required],
};

//查封起始时间
const cfqssj = {
  title: '查封起始时间',
  span: 12,
  type: 'date',
  key: 'cfqssj',
  props: {
    placeholder: '请选择查封起始时间',
  },
  ruleFunction: (Object) => {
    return [rules.required, rules.beforeTime(Object['cfjssj'])];
  },
};
// 房屋年代竣工日期
const jgsj = {
  title: '房屋年代竣工日期',
  span: 12,
  type: 'date',
  key: 'jgsj',
  props: {
    placeholder: '请选择房屋年代竣工日期',
  },
  rule: [rules.required],
};
// 房屋单元号
const dyh = {
  title: '房屋单元号',
  span: 12,
  type: 'input',
  key: 'dyh',
  props: {
    placeholder: '请选择房屋单元号',
    type: '房屋单元号',
  },
  rule: [rules.required],
};
//查封结束时间
const cfjssj = {
  title: '查封结束时间',
  span: 12,
  type: 'date',
  props: {
    placeholder: '请选择查封结束时间',
  },
  key: 'cfjssj',
  ruleFunction: (Object) => {
    return [rules.required, rules.afterTime(Object['cfqssj'])];
  },
};

//查封文号
const cfwh = {
  title: '查封裁定文书文号',
  span: 12,
  type: 'input',
  key: 'cfwh',
  props: {
    placeholder: '请填写查封裁定文书文号',
  },
  rule: [rules.required],
};

//查封文件
const cfwj = {
  title: '协助执行文书文号',
  span: 12,
  type: 'input',
  key: 'cfwj',
  props: {
    placeholder: '请填写协助执行文书文号',
  },
  rule: [rules.required],
};

//查封机关
const cfjg = {
  title: '查封机关',
  span: 12,
  type: 'input',
  key: 'cfjg',
  props: {
    placeholder: '请填写查封机关',
  },
  rule: [rules.required],
};
const zddm = {
  title: '宗地代码',
  span: 12,
  type: 'input',
  key: 'zddm',
  props: {
    placeholder: '请填写宗地代码',
    type: '宗地代码',
  },
  rule: [rules.required],
};
//查封范围
const cffw = {
  title: '查封范围',
  span: 12,
  type: 'input',
  key: 'cffw',
  props: {
    placeholder: '请填写查封范围',
  },
  rule: [rules.required],
};

//解封文号
const jfwh = {
  title: '解封文号',
  span: 12,
  type: 'input',
  key: 'jfwh',
  props: {
    placeholder: '请填写解封文号',
  },
  rule: [rules.required],
};

//解封文件
const jfwj = {
  title: '解封文件',
  span: 12,
  type: 'input',
  key: 'jfwj',
  props: {
    placeholder: '请填写解封文件',
  },
  rule: [rules.required],
};
//查封期限
const cfqx = {
  title: '查封期限',
  span: 12,
  type: 'input',
  key: 'cfqx',
  props: {
    placeholder: '',
    disabled: true,
  },
  // 计算抵押期限
  computedFn(item) {
    if (item.cfqssj && item.cfjssj) {
      let cfqxDate = Math.trunc(Math.abs(item.cfjssj - item.cfqssj) / (1000 * 24 * 3600));
      let cfqxYears = Math.abs(item.cfjssj - item.cfqssj) / (1000 * 24 * 3600 * 365);
      if (cfqxYears < 1 || cfqxYears === 1) {
        //一年以内，展示天数
        return `${Math.trunc(cfqxDate) + 1}天`;
      } else {
        //大于一年，展示年数+天数
        return `${Math.trunc(cfqxYears)}年${cfqxDate - Math.trunc(cfqxYears) * 365}天`;
      }
    }
  },
};
//解封机关
const jfjg = {
  title: '解封机关',
  span: 12,
  type: 'input',
  key: 'jfjg',
  props: {
    placeholder: '请填写解封机关',
  },
  rule: [rules.required],
};

/**
 * 预告抵押信息
 */
//预售商品房抵押权预告 3
//预售商品房买卖预告 1
const ygdjzl1 = {
  title: '预售登记种类',
  span: 12,
  type: 'dicSelect',
  key: 'ygdjzl',
  props: {
    placeholder: '请选择预售登记种类',
    type: '预告登记种类',
    disabled: true,
  },
  value: '1',
  rule: [rules.required],
};
//存量房买卖
const ygdjzl2 = {
  title: '预售登记种类',
  span: 12,
  type: 'dicSelect',
  key: 'ygdjzl',
  props: {
    placeholder: '请选择预售登记种类',
    type: '预告登记种类',
    disabled: true,
  },
  value: '2',
  rule: [rules.required],
};
const ygdjzl3 = {
  title: '预售登记种类',
  span: 12,
  type: 'dicSelect',
  key: 'ygdjzl',
  props: {
    placeholder: '请选择预售登记种类',
    type: '预告登记种类',
    disabled: true,
  },
  value: '3',
  rule: [rules.required],
};

//被担保债权数额
const bdbzzqse = {
  title: '被担保债权数额(万元)',
  span: 12,
  type: 'input',
  key: 'bdbzzqse',
  props: {
    placeholder: '请填写被担保债权数额(万元)',
  },
  rule: [rules.required, rules.number],
  ifRender(object) {
    return (object && object.dyfs === '1') || !object.dyfs;
  },
};

//债务履行起始时间
const zwlxqssj = {
  title: '债务履行起始时间',
  span: 12,
  type: 'date',
  key: 'zwlxqssj',
  props: {
    placeholder: '请选择债务履行起始时间',
  },
  ruleFunction: (Object) => {
    return [rules.required, rules.beforeTime(Object['zwlxjssj'])];
  },
};

//债务履行终止时间
const zwlxjssj = {
  title: '债务履行终止时间',
  span: 12,
  type: 'date',
  key: 'zwlxjssj',
  props: {
    placeholder: '请选择债务履行终止时间',
  },
  ruleFunction: (Object) => {
    return [rules.required, rules.afterTime(Object['zwlxqssj'])];
  },
};
//预告约定期限起
const ygydqssj = {
  title: '预告约定期限起',
  span: 12,
  type: 'date',
  key: 'ygydqssj',
  props: {
    placeholder: '请选择预告约定起始时间',
  },
  ruleFunction: (Object) => {
    return [rules.required, rules.beforeTime(Object['ygydjssj'])];
  },
};

//预告约定期限止
const ygydjssj = {
  title: '预告约定期限止',
  span: 12,
  type: 'date',
  key: 'ygydjssj',
  props: {
    placeholder: '请选择预告约定终止时间',
  },
  ruleFunction: (Object) => {
    return [rules.required, rules.afterTime(Object['ygydqssj'])];
  },
};

//抵押期限
const dyqx = {
  title: '抵押期限',
  span: 12,
  type: 'input',
  key: 'dyqx',
  props: {
    placeholder: '',
    disabled: true,
  },
  // 计算抵押期限
  computedFn(item) {
    if (item.zwlxjssj && item.zwlxqssj) {
      let dyqxDate = Math.trunc(Math.abs(item.zwlxjssj - item.zwlxqssj) / (1000 * 24 * 3600));
      let dyqxYears = Math.abs(item.zwlxjssj - item.zwlxqssj) / (1000 * 24 * 3600 * 365);
      if (dyqxYears < 1 || dyqxYears === 1) {
        //一年以内，展示天数
        return `${Math.trunc(dyqxDate)}天`;
      } else {
        //大于一年，展示年数+天数
        return `${Math.trunc(dyqxYears)}年${dyqxDate - Math.trunc(dyqxYears) * 365}天`;
      }
    }
  },
};

// //不动产登记证明号
// const bdcdjzmh = {
//   title: '不动产登记证明号',
//   span: 24,
//   type: 'imput',
//   key: 'bdcdjzmh',
//   props: {
//     // mbanType: '抵押证明模板'
//   }
//   //   rule: [rules.required]
// };
const bdcdjzmh = {
  title: '不动产登记证明号',
  span: 24,
  // type: localDataPermissionData.includes('IEBDC:SQ:CQZHY') ? 'chooseBdcqzh' : 'input',
  // type: 'chooseBdcqzh',
  type: 'input',
  key: 'bdcdjzmh',
  props: {
    placeholder: '兵（年份）(登记机构所在市县) 不动产证明第 0000001～9999999 号',
    // mbanType: localDataPermissionData.includes('IEBDC:SQ:CQZHY') ? '抵押证明模板' : ''
    // mbanType: '抵押证明模板'
  },
  rule: [rules.required],
};

//抵押方式
const dyfs = {
  title: '抵押方式',
  span: 12,
  placeholder: '请选择抵押方式',
  type: 'dicSelect',
  key: 'dyfs',
  props: {
    placeholder: '请选择抵押方式',
    type: '抵押方式',
  },
  rule: [rules.required],
};

//最高债权数额(万元)
const zgzqse = {
  title: '最高债权数额(万元)',
  span: 12,
  type: 'input',
  key: 'zgzqse',
  props: {
    placeholder: '请填写最高债权数额(万元)',
  },
  rule: [rules.required, rules.number],
  ifRender(object) {
    return object && object.dyfs === '2';
  },
};

//最高债权确定事实
const zgzqqdss = {
  title: '最高债权确定事实',
  span: 24,
  type: 'input',
  key: 'zgzqqdss',
  props: {
    placeholder: '请填写最高债权确定事实',
  },
  rule: [],
  ifRender(object) {
    return object && object.dyfs === '2';
  },
};

//在建工程范围
const zjjzwdyfw = {
  title: '在建工程范围',
  span: 24,
  type: 'input',
  key: 'zjjzwdyfw',
  props: {
    placeholder: '在建工程范围',
  },
  rule: [rules.required],
};

//不动产评估价值
const bdcpgjz = {
  title: '不动产评估价值(万元)',
  span: 12,
  type: 'input',
  key: 'bdcpgjz',
  props: {
    placeholder: '不动产评估价值',
  },
  rule: [rules.required, rules.number, rules.min(0)],
};
//不动产评估价值（非必填）
const bdcpgjzNoRequired = {
  title: '不动产评估价值(万元)',
  span: 12,
  type: 'input',
  key: 'bdcpgjz',
  props: {
    placeholder: '不动产评估价值',
  },
  rule: [rules.number, rules.min(0)],
};

//附记
const fj = {
  title: '附记',
  span: 12,
  type: 'input',
  key: 'fj',
  props: {
    placeholder: '附记',
  },
  rule: [],
};
//备注
const bz = {
  title: '备注',
  span: 24,
  type: 'input',
  key: 'bz',
  props: {
    placeholder: '备注',
  },
  rule: [],
};
//抵押物价值
const dywjz = {
  title: '抵押物价值(万元)',
  span: 12,
  type: 'input',
  key: 'dywjz',
  props: {
    placeholder: '抵押物价值',
  },
  rule: [rules.required],
};
//主债权合同编号
const zzqhtbh = {
  title: '主债权合同编号',
  span: 12,
  type: 'input',
  key: 'zzqhtbh',
  props: {
    placeholder: '主债权合同编号',
  },
  rule: [],
};
//抵押合同编号
const dyhtbh = {
  title: '抵押合同编号',
  span: 12,
  type: 'input',
  key: 'dyhtbh',
  props: {
    placeholder: '抵押合同编号',
  },
  rule: [],
};

//不动产详情信息
//项目名称
const xmmc = {
  title: '项目名称',
  span: 12,
  props: {
    placeholder: '请填写项目名称',
  },
  type: 'input',
  key: 'xmmc',
  rule: [rules.required],
};

//幢号
const zh = {
  title: '幢号',
  span: 12,
  type: 'input',
  key: 'zh',
  props: {
    placeholder: '请填写幢号',
  },
  rule: [rules.required, rules.number],
};

//房屋结构
const fwjg = {
  title: '房屋结构',
  span: 12,
  type: 'dicSelect',
  key: 'fwjg',
  props: {
    placeholder: '请选择房屋结构',
    type: '房屋结构',
  },
  rule: [rules.required],
};

//所在层
const szc = {
  title: '所在层',
  span: 12,
  type: 'input',
  key: 'szc',
  props: {
    placeholder: '请填写所在层',
  },
  rule: [rules.required, rules.number],
};

//总层数
const zcs = {
  title: '总层数',
  span: 12,
  type: 'input',
  key: 'zcs',
  props: {
    placeholder: '请填写总层数',
  },
  rule: [rules.required, rules.number],
};

//是否抵押
const sfdy = {
  title: '是否抵押',
  span: 12,
  type: 'radio',
  key: 'sfdy',
  props: {
    placeholder: '请选择是否抵押',
    options: [
      {
        value: '0',
        label: '否',
      },
      {
        value: '1',
        label: '是',
      },
    ],
  },
  rule: [rules.required],
};

//是否查封
const sfcf = {
  title: '是否查封',
  span: 12,
  type: 'radio',
  key: 'sfcf',
  props: {
    placeholder: '请选择是否查封',
    options: [
      {
        value: '0',
        label: '否',
      },
      {
        value: '1',
        label: '是',
      },
      {
        value: '2',
        label: '预查封',
      },
    ],
  },
  rule: [rules.required],
};

//是否异议
const sfyy = {
  title: '是否异议',
  span: 12,
  type: 'radio',
  key: 'sfyy',
  props: {
    placeholder: '请选择是否异议',
    options: [
      {
        value: '0',
        label: '否',
      },
      {
        value: '1',
        label: '是',
      },
    ],
  },
  rule: [rules.required],
};

//是否预告
const sfyg = {
  title: '是否预告',
  span: 12,
  type: 'radio',
  key: 'sfyg',
  props: {
    placeholder: '请选择是否预告',
    options: [
      {
        value: '0',
        label: '否',
      },
      {
        value: '1',
        label: '是',
      },
    ],
  },
  rule: [rules.required],
};

//室号部位
const shbw = {
  title: '室号部位',
  span: 12,
  type: 'input',
  key: 'shbw',
  props: {
    placeholder: '请填写室号部位',
  },
  rule: [rules.required],
};

//建筑面积
const jzmj = {
  title: '建筑面积',
  span: 12,
  type: 'input',
  key: 'jzmj',
  props: {
    placeholder: '请填写建筑面积',
  },
  rule: [rules.required, rules.number],
};

//套内建筑面积
const tnjzmj = {
  title: '套内建筑面积',
  span: 12,
  type: 'input',
  key: 'tnjzmj',
  props: {
    placeholder: '请填写套内建筑面积',
  },
  rule: [rules.number],
};

//分摊建筑面积
const ftjzmj = {
  title: '分摊建筑面积',
  span: 12,
  type: 'input',
  key: 'ftjzmj',
  props: {
    placeholder: '请填写分摊建筑面积',
  },
  rule: [rules.number],
};
//产权来源
const cqly = {
  title: '产权来源',
  width: '300px',
  span: 24,
  type: 'dicSelect',
  key: 'sfxzdy',
  props: {
    placeholder: '产权来源',
  },
  value: '0',
  rule: [rules.required],
};
//担保范围
const dbfw = {
  title: '担保范围',
  span: 24,
  type: 'input',
  key: 'dbfw',
  props: {
    placeholder: '担保范围',
  },
  rule: [rules.required],
};
//是否限制抵押
const sfxzdy = {
  title: '是否存在禁止或限制转让抵押不动产的约定',
  width: '300px',
  span: 24,
  type: 'dicSelect',
  key: 'sfxzdy',
  props: {
    placeholder: '请选择是否存在禁止或限制转让抵押不动产的约定',
    type: '是否',
  },
  value: '1',
  rule: [rules.required],
};
//房屋用途
const fwyt = {
  title: '房屋用途',
  span: 12,
  type: 'dicSelect',
  key: 'fwyt',
  props: {
    placeholder: '请选择房屋用途',
    type: '房屋用途',
  },
  rule: [],
};

//土地用途
const tdyt = {
  title: '土地用途',
  span: 12,
  type: 'dicSelect',
  key: 'tdyt',
  props: {
    placeholder: '请选择土地用途',
    type: '土地用途',
  },
  rule: [],
};

/**
 * 出让人房屋信息
 */
//出让人房屋取得时间
const crrfwqdsj = {
  title: '出让人房屋取得时间',
  span: 12,
  type: 'date',
  key: 'crrfwqdsj',
  props: {
    placeholder: '请选择出让人房屋取得时间',
  },
  rule: [rules.required],
};

//房屋朝向
const fwcx = {
  title: '房屋朝向（必填）',
  span: 12,
  type: 'input',
  key: 'fwcx',
  props: {
    placeholder: '请选择房屋朝向',
    type: '房屋朝向',
  },
  rule: [rules.required],
};
const fwcxFbt = {
  title: '房屋朝向',
  span: 12,
  type: 'input',
  key: 'fwcx',
  props: {
    placeholder: '请选择房屋朝向',
    type: '房屋朝向',
  },
  rule: [],
};

//出让人取得方式
const crrqdfs = {
  title: '房产交易方式',
  span: 12,
  type: 'dicSelect',
  key: 'crrqdfs',
  props: {
    placeholder: '请选择房产交易方式',
    type: '房产交易方式',
  },
  rule: [rules.required],
};

//房屋性质
const fwxz = {
  title: '房屋性质',
  span: 12,
  type: 'dicSelect',
  key: 'fwxz',
  props: {
    placeholder: '请选择房屋性质',
    type: '房屋性质',
  },
  rule: [rules.required],
};

//房产类型
const fwlx = {
  title: '房屋类型',
  span: 12,
  type: 'dicSelect',
  key: 'fwlx',
  props: {
    placeholder: '请选择房屋类型',
    type: '房屋类型',
  },
  rule: [rules.required],
};

//车库类型
const cklx = {
  title: '车库类型',
  span: 12,
  type: 'dicSelect',
  key: 'cklx',
  props: {
    placeholder: '请选择车库类型',
    type: '车库类型',
  },
  rule: [rules.required],
};

//容积率
const rjl = {
  title: '容积率(%)',
  span: 12,
  type: 'input',
  key: 'rjl',
  props: {
    placeholder: '请填写容积率',
  },
  rule: [rules.required, rules.min(0.01), rules.max(100)],
};
//购房合同编号
const gfhtbh = {
  title: '购房合同编号(必填)',
  span: 12,
  type: 'input',
  key: 'gfhtbh',
  props: {
    placeholder: '购房合同编号',
  },
  rule: [rules.required],
  // ruleFunction: (formData) => {
  //   if (formData.ywms === '1' || !formData.ywms.length) {
  //     return [rules.noRequired];
  //   }
  //   if (formData.ywms === '2' || formData.ywms === '3') {
  //     return [rules.required];
  //   }
  // }
};
const gfhtbhFbt = {
  title: '购房合同编号',
  span: 12,
  type: 'input',
  key: 'gfhtbh',
  props: {
    placeholder: '购房合同编号',
  },
  rule: [],
};

//纳税人识别号
const nsrsbh = {
  title: '纳税人识别号',
  span: 12,
  type: 'input',
  key: 'nsrsbh',
  props: {
    placeholder: '请填写纳税人识别号',
  },
  ruleFunction: (formData) => {
    if (formData.ywms === '1' || formData.ywms === '2' || !formData.ywms.length) {
      return [rules.noRequired];
    }
    if (formData.ywms === '3') {
      return [rules.required];
    }
  },
};

/**
 * 房屋转移信息
 */
//业务模式
const ywms = {
  title: '业务模式',
  span: 12,
  type: 'dicSelect',
  key: 'ywms',
  props: {
    placeholder: '请选择业务模式',
    type: '业务模式',
  },
  rule: [rules.required],
};
//房屋状态
const fwzt = {
  title: '房屋状态',
  span: 12,
  type: 'dicSelect',
  key: 'fwzt',
  props: {
    placeholder: '请选择房屋状态',
    type: '房屋状态',
  },
  rule: [rules.required],
};
//证书模式
const zsms = {
  title: '证书模式',
  span: 12,
  type: 'dicSelect',
  key: 'zsms',
  props: {
    placeholder: '请选择证书模式',
    type: '证书模式',
  },
  rule: [rules.required],
};
//缴费、领证方式
const jffs = {
  title: '缴费、领证方式',
  span: 12,
  type: 'dicSelect',
  key: 'jffs',
  props: {
    placeholder: '请选择缴费、领证方式',
    type: '缴费、领证方式',
  },
  rule: [rules.required],
};
//申请类型
const sqlx = {
  title: '申请类型',
  span: 12,
  type: 'dicSelect',
  key: 'sqlx',
  props: {
    placeholder: '请选择申请类型',
    type: '申请类型',
  },
  rule: [rules.required],
};

//登记事由
const djsy = {
  title: '登记事由',
  span: 24,
  type: 'dicSelect',
  key: 'djsy',
  props: {
    placeholder: '请选择登记事由',
    type: '登记事由',
  },
  rule: [rules.required],
};

//房屋交易时间
const fwjysj = {
  title: '房屋交易时间',
  span: 12,
  type: 'date',
  props: {
    placeholder: '请选择房屋交易时间',
  },
  key: 'fwjysj',
  ruleFunction: (Object) => {
    return [rules.required];
  },
};

//房屋交易时间
const fwjysjNew = {
  title: '交易时间',
  span: 12,
  type: 'date',
  props: {
    placeholder: '请选择交易时间',
  },
  key: 'fwjysj',
  ruleFunction: (Object) => {
    return [rules.required];
  },
};
//是否备案
const sfba = {
  title: '是否备案',
  span: 12,
  type: 'dicSelect',
  key: 'sfba',
  props: {
    placeholder: '请选择是否备案',
    type: '是否',
  },
  value: '0',
  rule: [rules.required],
};

//是否完税
const sfws = {
  title: '是否完税',
  span: 12,
  type: 'dicSelect',
  key: 'sfws',
  props: {
    placeholder: '请选择是否完税',
    type: '是否',
  },
  value: '0',
  rule: [rules.required],
};

//备案合同号
const bahtbh = {
  title: '备案合同号',
  span: 12,
  type: 'input',
  key: 'bahtbh',
  props: {
    placeholder: '请填写备案合同号',
  },
  ifRender(object) {
    return object && object.sfba === '0';
  },

  // rule: [rules.estateUnitNo]
};
//备案合同号必填
const bahtbhRqd = {
  title: '备案合同号',
  span: 12,
  type: 'input',
  key: 'bahtbh',
  props: {
    placeholder: '请填写备案合同号',
  },
  ifRender(object) {
    return object && object.sfba === '1';
  },
  rule: [rules.required],
};

//完税凭证号
const wspzh = {
  title: '完税凭证号',
  span: 12,
  type: 'input',
  key: 'wspzh',
  props: {
    placeholder: '请填写完税凭证号',
  },
  ifRender(object) {
    return object && object.sfws === '0';
  },
  // rule: [rules.estateUnitNo]
};
//完税凭证号必填
const wspzhRqd = {
  title: '完税凭证号',
  span: 12,
  type: 'input',
  key: 'wspzh',
  props: {
    placeholder: '请填写完税凭证号',
  },
  ifRender(object) {
    return object && object.sfws === '1';
  },
  rule: [rules.required],
};

//房屋变更,房屋转移,房屋注销,房屋更正,换证,补证,土地转移
export const fwzyQlxxExForm = [
  {
    title: '其他申请信息',
    value: [sqzsbs, sffbcz, sfdbz, cqly, sqdjyy, bz],
  },
];

//一窗信息
export const fwzyYcxxExForm = [
  {
    title: '一窗信息',
    value: [sfba, bahtbh, bahtbhRqd, sfws, wspzh, wspzhRqd],
  },
];

//房屋转移
export const fwzyQlxxForm = [
  {
    title: '不动产信息',
    value: [bdcqzh, zl, bdcdyh, fwcqmj, fwjyjg],
    // value: [bdcqzh, zl, bdcdyh, fwcqmj, fwjyjg, tdsyqr]
  },
];
export const fwzyycQlxxForm = [
  {
    title: '不动产信息',
    value: [bdcqzh, zl, bdcdyh, fwcqmj],
    // value: [bdcqzh, zl, bdcdyh, fwcqmj, fwjyjg, tdsyqr]
  },
  {
    title: '房屋当前情况',
    value: [zh, fwjg, szc, zcs, sfdy, sfcf, sfyy, sfyg],
  },
  {
    title: '出让人房屋信息',
    value: [crrfwqdsj, fwcx, crrqdfs, fwjyjg, fwxz, fwlx, cklx, rjl],
  },
];
// export const fwzyycQlxxExForm = [
//   {
//     title: '房屋转移信息',
//     value: [ywms, fwzt, gfhtbh, nsrsbh, zsms, jffs, sqlx, djsy, sqdjyy]
//   }
// ];
//房屋变更,房屋更正,换证,补证,一般抵押权首次,在建抵押权首次,抵押权注销
export const fwbgQlxxForm = [
  {
    title: '不动产信息',
    value: [bdcqzh, zl, bdcdyh, fwcqmj, bdcdjzmh],
    // value: [bdcqzh, zl, bdcdyh, fwcqmj, tdsyqr]
  },
];
//补证换证
export const bzhzQlxxForm = [
  {
    //value: [bdcqzh, zl, bdcdyh, tdyt, zdmj, tdsyqmj, syqqssj, syqjssj, tdsyqr],
    value: [bdcqzh, zl, bdcdyh, fwcqmj],
  },
];
//抵押权首次登记
export const dyscQlxxForm = [
  {
    title: '不动产信息',
    value: [bdcqzh, zl, bdcdyh, fwcqmj],
    // value: [bdcqzh, zl, bdcdyh, fwcqmj, tdsyqr]
  },
];
//房屋首次
export const fwscQlxxForm = [
  {
    title: '不动产信息',
    value: [zl, bdcdyh, fwcqmj],
    // value: [zl, bdcdyh, fwcqmj, tdsyqr]
  },
];

//房屋注销
export const fwzxQlxxForm = [
  {
    title: '不动产信息',
    value: [bdcqzh, zl, bdcdyh],
    // value: [bdcqzh, zl, bdcdyh, tdsyqr]
  },
];
//房屋查封
export const fwcfQlxxForm = [
  {
    title: '不动产信息',
    value: [bdcqzhNoreq, zl, bdcdyh, fwcqmj],
  },
];
//土地抵押权首次登记
export const tddyqscQlxxForm = [
  {
    title: '抵押信息(单位:平方米、万元)',
    value: [dyfs, bdbzzqse, zgzqse, zgzqqdss, bdcpgjz, zwlxqssj, zwlxjssj, sqdjyy, bz],
  },
];
//土地抵押权注销
export const tddyqzxQlxxForm = [
  {
    title: '抵押信息(单位:平方米、万元)',
    value: [bdcdjzmh, dyfs, bdbzzqse, zgzqse, zgzqqdss, bdcpgjz, zwlxqssj, zwlxjssj, sqdjyy, bz],
  },
];
//房屋查封
export const fwcfQlxxExForm = [
  {
    title: '查封信息',
    value: [ygr, cflx, cfqssj, cfjssj, cfwh, cfwj, cfjg, cffw, sqdjyy, bz],
  },
];
//房屋解封
export const fwjfQlxxExForm = [
  {
    title: '查封信息',
    value: [ygr, cflx, cfqssj, cfjssj, cfwh, cfwj, cfjg, cffw, jfjg, jfwh, jfwj, sqdjyy, bz],
  },
];
//预告抵押,预告抵押注销
export const mmygQlxxForm = [
  {
    title: '不动产信息',
    value: [zl, bdcdyh, fwcqmj, qdjgNotRequired, bdcdjzmh],
  },
];
//预告买卖,预告买卖注销
export const mmygQlxxFormN = [
  {
    title: '不动产信息',
    value: [zl, bdcdyh, ycjzmjRequired, fwyt],
  },
];
//预告买卖,预告买卖注销
export const mmygQlxxExForm = [
  {
    title: '预告信息(单位:平方米、万元)',
    value: [jyjgNewRequired, fwjysjNew, gfhtbh, ygdjzl1, sqdjyy, bz],
  },
];

//存量房买卖预告
export const clfmmygQlxxExForm = [
  {
    title: '预告信息(单位:平方米、万元)',
    value: [ygydqssj, ygydjssj, jyjgNewRequired, fwjysjNew, ygdjzl2, sqdjyy, bz],
  },
];

//转本位转移登记权力信息
export const zbwzyQlxxExForm = [
  {
    title: '权利信息(单位:平方米、万元)',
    value: [jyjgNewRequired, fwjysjNew],
  },
];
//查封登记
export const fwcfxxExForm = [
  {
    title: '查封信息',
    value: [cflx, ygr, cfjg, cfwj, cfwh, cffw, cfqssj, cfjssj, cfqx, sqdjyy, bz],
  },
];
//预告注销
export const mmygzxQlxxExForm = [
  {
    title: '预告信息(单位:平方米、万元)',
    value: [bdcdjzmh, ygdjzl1, sqdjyy, bz],
  },
];

//预告抵押
export const dyygQlxxExForm1 = [
  {
    title: '预告买卖权利信息(单位:平方米、万元)',
    value: [jyjgNewRequired, fwjysjNew, gfhtbh, ygdjzl1, sqdjyy],
  },
];
export const dyygQlxxExForm2 = [
  {
    title: '预告抵押权利信息(单位:平方米、万元)',
    value: [
      ygdjzl3,
      dyfs,
      bdbzzqse,
      zgzqse,
      zgzqqdss,
      dywjz,
      zwlxqssj,
      zwlxjssj,
      zzqhtbh,
      dyhtbh,
      fj,
      dbfw,
      sqdjyy,
      bz,
    ],
  },
];
//预告抵押
export const dyygQlxxExForm = [
  {
    title: '抵押信息(单位:平方米、万元)',
    value: [
      ygdjzl3,
      dyfs,
      bdbzzqse,
      zgzqse,
      zgzqqdss,
      dywjz,
      zwlxqssj,
      zwlxjssj,
      zzqhtbh,
      dyhtbh,
      fj,
      dbfw,
      sqdjyy,
      bz,
    ],
  },
];
//预告抵押注销, 一般抵押注销, 在建抵押注销
export const dyygzxQlxxExForm = [
  {
    title: '抵押信息(单位:平方米、万元)',
    value: [dyfs, bdbzzqse, zgzqse, zgzqqdss, zwlxqssj, zwlxjssj, sqdjyy, bz],
  },
];
//抵押变更
export const dybgQlxxExForm = [
  {
    title: '抵押信息(单位:平方米、万元)',
    value: [dyfs, bdbzzqse, zgzqse, zgzqqdss, zwlxqssj, zwlxjssj, zzqhtbh, dyhtbh, dywjz, fj, sqdjyy, bz],
  },
];
//预告抵押注销
export const ygdyzxQlxxExForm = [
  {
    title: '抵押信息(单位:平方米、万元)',
    value: [bdcdjzmh, bdbzzqse, zgzqse, zgzqqdss, zwlxqssj, zwlxjssj, sqdjyy, bz],
  },
];
//一般抵押权首次
export const ybdyqscQlxxExForm = [
  {
    title: '抵押信息(单位:平方米、万元)',
    // value: [dyfs, bdbzzqse, zgzqse, zgzqqdss, bdcpgjzNoRequired, dyqx, zwlxqssj, zwlxjssj, dbfw, sqdjyy]
    value: [dyfs, bdbzzqse, zgzqse, zgzqqdss, sfxzdy, zwlxqssj, zwlxjssj, dbfw, zzqhtbh, dyhtbh, dywjz, fj, sqdjyy, bz],
  },
];
//在建抵押权首次
export const zjdyqscQlxxExForm = [
  {
    title: '抵押信息(单位:平方米、万元)',
    value: [zjjzwdyfw, dyfs, bdbzzqse, zgzqse, zgzqqdss, zwlxqssj, zwlxjssj, sqdjyy, bz],
  },
];

//房屋首次登记
//所有不动产表格详情弹框都使用的此配置
export const fwscQlxxDialogForm = [
  {
    title: '不动产信息',
    value: [zl, bdcdyh, fwcqmj, jzmj, tnjzmj, ftjzmj, fwyt],
  },
  // {
  //   title: '幢户详情',
  //   value: [xmmc, zh, shbw, jzmj, tnjzmj, ftjzmj, fwyt]
  // }
];

//除抵押首次、抵押变更、抵押注销/预告、房屋变更之外，所有不动产表格详情弹框都使用的此配置
export const qlxxDialogForm = [
  {
    title: '不动产信息',
    value: [bdcqzh, zl, bdcdyh, fwcqmj, fwjyjg, jzmj, tnjzmj, ftjzmj, fwyt],
  },
  // {
  //   title: '幢户详情',
  //   value: [xmmc, zh, shbw, jzmj, tnjzmj, ftjzmj, fwyt]
  // }
];
//房屋转移登记New
export const fwzydjNewDialogForm = [
  {
    title: '不动产信息',
    value: [bdcqzh, zl, bdcdyh, fwcqmj, fwjyjgRequired, fwjysj, jzmj, tnjzmj, ftjzmj, fwyt],
    // value: [bdcqzh, zl, bdcdyh, fwcqmj, fwjyjg, tdsyqr]
  },
];
export const fwzyycQlxxFormN200104 = [
  {
    // value: [bdcqzh, zl, bdcdyh, fwcqmj]
    value: [
      bdcqzh, //产权证号
      zl, //坐落
      bdcdyh, //不动产单元号
      fwcqmj, // 房屋产权面积
      fwjyjg, // 房屋交易价格
      fwlx, //房屋类型 对应文档housetype
      crrqdfs, //房产交易方式
      fwcxFbt, //房屋朝向
      fwjg, //建筑结构
      fwyt, //房屋用途
      fwxz, //房屋性质
      jzmj, //建筑面积
      zddm, //宗地代码
      zh, //自然幢号
      dyh, //房屋单元号
      shbw, //室号
      szc, //实际层
      gfhtbhFbt, // 购房合同编号
      gfhtqdrq, //签约日期
      tdsyqqssj, //土地使用开始时间
      tdsyqjssj, //土地使用结束时间
      jgsj, //房屋年代竣工日期
    ],
  },
];
//转本位流程不动产信息
export const zbwqlxxDialogForm = [
  {
    title: '不动产信息',
    value: [bdcqzh, zl, bdcdyh, fwcqmj, jzmj, tnjzmj, ftjzmj, fwyt],
  },
  // {
  //   title: '幢户详情',
  //   value: [xmmc, zh, shbw, jzmj, tnjzmj, ftjzmj, fwyt]
  // }
];
//房屋抵押首次;抵押注销;抵押变更;房屋变更
export const otherqlxxDialogForm = [
  {
    title: '不动产信息',
    value: [bdcqzh, zl, bdcdyh, fwcqmj, jzmj, tnjzmj, ftjzmj, fwyt],
  },
  // {
  //   title: '幢户详情',
  //   value: [xmmc, zh, shbw, jzmj, tnjzmj, ftjzmj, fwyt]
  // }
];

//预告抵押注销不动产表格详情弹框
export const ygqlxxDialogForm = [
  {
    title: '不动产信息',
    value: [zl, bdcdyh, fwcqmj, fwjyjgNotRequired, jzmj, tnjzmj, ftjzmj, fwyt],
  },
  // {
  //   title: '幢户详情',
  //   value: [xmmc, zh, shbw, jzmj, tnjzmj, ftjzmj, fwyt]
  // }
];
//买卖预告、买卖预告注销登记不动产表格详情弹框
export const mmygqlxxDialogForm = [
  {
    title: '不动产信息',
    value: [zl, bdcdyh, ycjzmjRequired, jzmj, tnjzmj, ftjzmj, fwyt],
  },
  // {
  //   title: '幢户详情',
  //   value: [xmmc, zh, shbw, jzmj, tnjzmj, ftjzmj, fwyt]
  // }
];

//New预告流程不动产表格详情弹框
export const ygNewqlxxDialogForm = [
  {
    title: '不动产信息',
    value: [zl, bdcdyh, ycjzmjRequired, fwyt, jzmj, tnjzmj, ftjzmj, fwyt],
  },
  // {
  //   title: '幢户详情',
  //   value: [xmmc, zh, shbw, jzmj, tnjzmj, ftjzmj]
  // }
];
//存量房买卖预告登记不动产表格详情弹框
export const clfmmygqlxxDialogForm = [
  {
    title: '不动产信息',
    value: [bdcqzh, zl, bdcdyh, fwcqmj, jzmj, tnjzmj, ftjzmj, fwyt],
  },
  // {
  //   title: '幢户详情',
  //   value: [xmmc, zh, shbw, jzmj, tnjzmj, ftjzmj, fwyt]
  // }
];
export const clfQlxxForm = [
  {
    title: '不动产信息',
    value: [bdcqzh, zl, bdcdyh, fwcqmj],
  },
];
//预告抵押/预告抵押注销登记的不动产表格弹框
export const mmygqlxxDialogFormN = [
  {
    title: '不动产信息',
    value: [zl, bdcdyh, fwcqmj, qdjgNotRequired, jzmj, tnjzmj, ftjzmj, fwyt],
  },
  // {
  //   title: '幢户详情',
  //   value: [xmmc, zh, shbw, jzmj, tnjzmj, ftjzmj, fwyt]
  // }
];

//土地抵押权首次；土地抵押权注销
export const tddyqlxxDialogForm = [
  {
    title: '不动产信息',
    value: [bdcqzh, bdcdyh, zl, tdsyqmj],
  },
];
//土地变更
export const tdbgqlxxDialogForm = [
  {
    title: '不动产信息',
    value: [bdcdyh, zl, tdsyqmj, tdyt],
  },
];
